import { Link } from '@mui/material';

const URL_RE = /(https?:\/\/[^\s]+)/g;

// Кінцева пунктуація майже завжди належить реченню, а не URL
const trimTrail = (url) => url.replace(/[.,)!?;:]+$/, '');

/**
 * Рендерить текст, роблячи http(s)-посилання клікабельними.
 * split із capturing-групою чергує текст/URL: непарні індекси — посилання.
 */
const LinkifiedText = ({ text }) =>
  String(text ?? '')
    .split(URL_RE)
    .map((part, index) => {
      if (index % 2 === 0) {
        return part;
      }
      const clean = trimTrail(part);
      const tail = part.slice(clean.length);
      return (
        <span key={index}>
          <Link
            href={clean}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#4357AD', fontWeight: 600, wordBreak: 'break-all' }}
          >
            {clean}
          </Link>
          {tail}
        </span>
      );
    });

export default LinkifiedText;
